import { Box } from "@mui/material";
import type { GridRenderCellParams } from "@mui/x-data-grid";
import { DeleteButton } from "@components";
import { statisticsService } from "../services/statistics-service";

export const TableActionsCell = (props: GridRenderCellParams<any, any>) => {
  const isAvailable = props?.row.isDeletable !== false;
  const id = props?.row.id;

  if (isAvailable) {
    return (
      <Box sx={{ display: "flex" }}>
        <DeleteButton id={id} deleteService={statisticsService.deleteReport} label="Report" skipNavigate />
      </Box>
    );
  }

  return null;
};
